export default __webpack_public_path__ + "static/media/circle-bg-2.38a82881.svg";